import { styled } from '@mui/material/styles';

export const SignInPageContainer = styled('main')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: theme.spacing(0, 2),
  width: '100%',
}));

export const SignInContent = styled('div')({
  maxWidth: '700px',
  width: '100%',
});
